const required = (props) => {
    if (props.isRequired) {
        return props.isRequired
    } else {
        return false
    }
}

export default required